import { create } from 'zustand';

interface GlobalStore {
	pageTitle: string;
	setPageTitle: (title: string) => void;
}

export const useGlobalStore = create<GlobalStore>((set) => ({
	pageTitle: 'Dashboard',
	setPageTitle: (title: string) => set({ pageTitle: title }),
}));
